import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM9 18.5V20H15V18.5H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhone;
